import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class LocationsDtoActive{
    @ApiProperty()
    locationId:number;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    isActive : boolean;

    @ApiProperty()
    updatedUser : string;



}